<template>
  <button
    type="button"
    @click="$emit('click', $event)"
    :class="[
      'tw-flex tw-relative tw-justify-center tw-cursor-pointer focus:tw-shadow-outline tw-rounded-full tw-p-2 tw--m-2 tw-items-center tw-transition-color tw-duration-75 focus:tw-outline-none',
      colorClass,
    ]"
  >
    <base-spinner color="currentColor" :size="20" v-if="loading" />
    <slot v-else />
  </button>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "gray",
    },
    dark: Boolean,
    loading: Boolean,
  },
  computed: {
    colorClass() {
      return this.dark
        ? `tw-text-${this.color}-300 hover:tw-text-${this.color}-300 hover:tw-bg-${this.color}-700 focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-${this.color}-700`
        : `tw-text-${this.color}-500 hover:tw-text-${this.color}-500 hover:tw-bg-${this.color}-100 focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-${this.color}-500`;
    },
  },
};
</script>
